export const Timezones = [
    {
        label: '(GMT-1200) Etc/GMT+12',
        value: 'Etc/GMT+12',
        utc_offset: '-12:00',
    },
    {
        label: '(GMT-1100) Pacific/Pago_Pago',
        value: 'Pacific/Pago_Pago',
        utc_offset: '-11:00',
    },
    {
        label: '(GMT-1100) America/Adak',
        value: 'America/Adak',
        utc_offset: '-11:00',
    },
    {
        label: '(GMT-1100) Pacific/Apia',
        value: 'Pacific/Apia',
        utc_offset: '-11:00',
    },
    {
        label: '(GMT-1000) Pacific/Honolulu',
        value: 'Pacific/Honolulu',
        utc_offset: '-10:00',
    },
    {
        label: '(GMT-1030) Pacific/Marquesas',
        value: 'Pacific/Marquesas',
        utc_offset: '-10:30',
    },
    {
        label: '(GMT-0900) Pacific/Gambier',
        value: 'Pacific/Gambier',
        utc_offset: '-09:00',
    },
    {
        label: '(GMT-0900) America/Anchorage',
        value: 'America/Anchorage',
        utc_offset: '-09:00',
    },
    {
        label: '(GMT-0800) America/Los_Angeles',
        value: 'America/Los_Angeles',
        utc_offset: '-08:00',
    },
    {
        label: '(GMT-0800) Pacific/Pitcairn',
        value: 'Pacific/Pitcairn',
        utc_offset: '-08:00',
    },
    {
        label: '(GMT-0700) America/Phoenix',
        value: 'America/Phoenix',
        utc_offset: '-07:00',
    },
    {
        label: '(GMT-0600) America/Denver',
        value: 'America/Denver',
        utc_offset: '-06:00',
    },
    {
        label: '(GMT-0600) America/Guatemala',
        value: 'America/Guatemala',
        utc_offset: '-06:00',
    },
    {
        label: '(GMT-0600) America/Chicago',
        value: 'America/Chicago',
        utc_offset: '-06:00',
    },
    {
        label: '(GMT-0600) Pacific/Easter',
        value: 'Pacific/Easter',
        utc_offset: '-06:00',
    },
    {
        label: '(GMT-0500) America/Bogota',
        value: 'America/Bogota',
        utc_offset: '-05:00',
    },
    {
        label: '(GMT-0500) America/New_York',
        value: 'America/New_York',
        utc_offset: '-05:00',
    },
    {
        label: '(GMT-0430) America/Caracas',
        value: 'America/Caracas',
        utc_offset: '-04:30',
    },
    {
        label: '(GMT-0400) America/Halifax',
        value: 'America/Halifax',
        utc_offset: '-04:00',
    },
    {
        label: '(GMT-0400) America/Santo_Domingo',
        value: 'America/Santo_Domingo',
        utc_offset: '-04:00',
    },
    {
        label: '(GMT-0400) America/Asuncion',
        value: 'America/Asuncion',
        utc_offset: '-04:00',
    },
    {
        label: '(GMT-0330) America/St_Johns',
        value: 'America/St_Johns',
        utc_offset: '-03:30',
    },
    {
        label: '(GMT-0300) America/Godthab',
        value: 'America/Godthab',
        utc_offset: '-03:00',
    },
    {
        label: '(GMT-0300) America/Argentina/Buenos_Aires',
        value: 'America/Argentina/Buenos_Aires',
        utc_offset: '-03:00',
    },
    {
        label: '(GMT-0300) America/Montevideo',
        value: 'America/Montevideo',
        utc_offset: '-03:00',
    },
    {
        label: '(GMT-0200) America/Noronha',
        value: 'America/Noronha',
        utc_offset: '-02:00',
    },
    {
        label: '(GMT-0200) Etc/GMT+2',
        value: 'Etc/GMT+2',
        utc_offset: '-02:00',
    },
    {
        label: '(GMT-0100) Atlantic/Azores',
        value: 'Atlantic/Azores',
        utc_offset: '-01:00',
    },
    {
        label: '(GMT-0100) Atlantic/Cape_Verde',
        value: 'Atlantic/Cape_Verde',
        utc_offset: '-01:00',
    },
    {
        label: '(GMT+0000) Africa/Casablanca',
        value: 'Africa/Casablanca',
        utc_offset: '00:00',
    },
    {
        label: '(GMT+0000) Europe/London',
        value: 'Europe/London',
        utc_offset: '00:00',
    },
    {
        label: '(GMT+0100) Europe/Berlin',
        value: 'Europe/Berlin',
        utc_offset: '+01:00',
    },
    {
        label: '(GMT+0100) Africa/Lagos',
        value: 'Africa/Lagos',
        utc_offset: '+01:00',
    },
    {
        label: '(GMT+0100) Africa/Windhoek',
        value: 'Africa/Windhoek',
        utc_offset: '+01:00',
    },
    {
        label: '(GMT+0200) Asia/Beirut',
        value: 'Asia/Beirut',
        utc_offset: '+02:00',
    },
    {
        label: '(GMT+0200) Africa/Johannesburg',
        value: 'Africa/Johannesburg',
        utc_offset: '+02:00',
    },
    {
        label: '(GMT+0300) Europe/Moscow',
        value: 'Europe/Moscow',
        utc_offset: '+03:00',
    },
    {
        label: '(GMT+0300) Asia/Baghdad',
        value: 'Asia/Baghdad',
        utc_offset: '+03:00',
    },
    {
        label: '(GMT+0330) Asia/Tehran',
        value: 'Asia/Tehran',
        utc_offset: '+03:30',
    },
    {
        label: '(GMT+0400) Asia/Dubai',
        value: 'Asia/Dubai',
        utc_offset: '+04:00',
    },
    {
        label: '(GMT+0400) Asia/Yerevan',
        value: 'Asia/Yerevan',
        utc_offset: '+04:00',
    },
    {
        label: '(GMT+0430) Asia/Kabul',
        value: 'Asia/Kabul',
        utc_offset: '+04:30',
    },
    {
        label: '(GMT+0500) Asia/Yekaterinburg',
        value: 'Asia/Yekaterinburg',
        utc_offset: '+05:00',
    },
    {
        label: '(GMT+0500) Asia/Karachi',
        value: 'Asia/Karachi',
        utc_offset: '+05:00',
    },
    {
        label: '(GMT+0530) Asia/Kolkata',
        value: 'Asia/Kolkata',
        utc_offset: '+05:30',
    },
    {
        label: '(GMT+0545) Asia/Kathmandu',
        value: 'Asia/Kathmandu',
        utc_offset: '+05:45',
    },
    {
        label: '(GMT+0600) Asia/Dhaka',
        value: 'Asia/Dhaka',
        utc_offset: '+06:00',
    },
    {
        label: '(GMT+0600) Asia/Omsk',
        value: 'Asia/Omsk',
        utc_offset: '+06:00',
    },
    {
        label: '(GMT+0630) Asia/Rangoon',
        value: 'Asia/Rangoon',
        utc_offset: '+06:30',
    },
    {
        label: '(GMT+0700) Asia/Krasnoyarsk',
        value: 'Asia/Krasnoyarsk',
        utc_offset: '+07:00',
    },
    {
        label: '(GMT+0700) Asia/Jakarta',
        value: 'Asia/Jakarta',
        utc_offset: '+07:00',
    },
    {
        label: '(GMT+0800) Asia/Shanghai',
        value: 'Asia/Shanghai',
        utc_offset: '+08:00',
    },
    {
        label: '(GMT+0800) Asia/Irkutsk',
        value: 'Asia/Irkutsk',
        utc_offset: '+08:00',
    },
    {
        label: '(GMT+0845) Australia/Eucla',
        value: 'Australia/Eucla',
        utc_offset: '+08:45',
    },
    {
        label: '(GMT+0900) Asia/Yakutsk',
        value: 'Asia/Yakutsk',
        utc_offset: '+09:00',
    },
    {
        label: '(GMT+0900) Asia/Tokyo',
        value: 'Asia/Tokyo',
        utc_offset: '+09:00',
    },
    {
        label: '(GMT+0930) Australia/Darwin',
        value: 'Australia/Darwin',
        utc_offset: '+09:30',
    },
    {
        label: '(GMT+0930) Australia/Adelaide',
        value: 'Australia/Adelaide',
        utc_offset: '+09:30',
    },
    {
        label: '(GMT+1000) Australia/Brisbane',
        value: 'Australia/Brisbane',
        utc_offset: '+10:00',
    },
    {
        label: '(GMT+1000) Asia/Vladivostok',
        value: 'Asia/Vladivostok',
        utc_offset: '+10:00',
    },
    {
        label: '(GMT+1000) Australia/Sydney',
        value: 'Australia/Sydney',
        utc_offset: '+10:00',
    },
    {
        label: '(GMT+1030) Australia/Lord_Howe',
        value: 'Australia/Lord_Howe',
        utc_offset: '+10:30',
    },
    {
        label: '(GMT+1100) Asia/Kamchatka',
        value: 'Asia/Kamchatka',
        utc_offset: '+11:00',
    },
    {
        label: '(GMT+1100) Pacific/Noumea',
        value: 'Pacific/Noumea',
        utc_offset: '+11:00',
    },
    {
        label: '(GMT+1130) Pacific/Norfolk',
        value: 'Pacific/Norfolk',
        utc_offset: '+11:30',
    },
    {
        label: '(GMT+1200) Pacific/Auckland',
        value: 'Pacific/Auckland',
        utc_offset: '+12:00',
    },
    {
        label: '(GMT+1200) Pacific/Tarawa',
        value: 'Pacific/Tarawa',
        utc_offset: '+12:00',
    },
    {
        label: '(GMT+1245) Pacific/Chatham',
        value: 'Pacific/Chatham',
        utc_offset: '+12:45',
    },
    {
        label: '(GMT+1300) Pacific/Tongatapu',
        value: 'Pacific/Tongatapu',
        utc_offset: '+13:00',
    },
    {
        label: '(GMT+1400) Pacific/Kiritimati',
        value: 'Pacific/Kiritimati',
        utc_offset: '+14:00',
    }
];
